export const maskPhone = (phone: string) => {
  return `${phone.slice(0, 3)}****${phone.slice(-3)}`;
};

export const maskEmail = (email: string) => {
  const [local, domain] = email.split('@');
  return `${local[0]}***@${domain}`.toLowerCase();
};
